








import { GPageBase } from '@/mixins';
import { mixins } from 'vue-class-component';
import { Component } from 'vue-property-decorator';
import { HumanitiesOrSciences } from '@/models/school-group/school-group-trend-analysis';
import { statisticsModule } from '@/store/modules/frames/statistics.module';
import GTrendAnalysisHumanitiesOrSciencesChart from '@/views/GClassManagement/GTrendAnalysisHumanitiesOrSciencesChart.vue';

@Component({
  name: 'GClassManagementTrendAnalysisHumanitiesOrSciences',
  components: {
    GTrendAnalysisHumanitiesOrSciencesChart,
  },
})
export default class GClassManagementTrendAnalysisHumanitiesOrSciences extends mixins(GPageBase) {
  mounted() {}

  get schoolGroupTrendAnalysisHumanitiesOrSciences(): HumanitiesOrSciences {
    return statisticsModule.schoolGroupTrendAnalysis.humanitiesOrSciences;
  }
}
